<template>
  <table-layout title="برگه ها" :showSearch="false">
    <template #buttons>
      <router-link :to="{ name: 'TrashContents' ,params: { type: 'pages' }, }">
        <b-button pill variant="danger"> سطل زباله</b-button>
      </router-link>

      <router-link :to="{ name: 'CreateContent' }" class="ml-2">
        <b-button pill variant="purple"> ساخت برگه جدید</b-button>
      </router-link>

      <b-button pill v-b-toggle.filters class="mx-1" variant="primary">فیلتر</b-button>

      <LanguageSelectBox @changeLanguage="getItems" module-name="content" class="mx-4"/>
    </template>
    <template #table>
      <b-collapse id="filters" class="mt-2">
        <div class="row">
          <div class="col-lg-4 align-self-end">
            <search-filter1 class="d-inline" @search="setSearch" ref="searchComponent"/>

          </div>
          <div class="col-lg-2 align-self-end" >
            <b-button class="d-inline"
                      @click="triggerSearch"
                      variant="primary"

            >
              جستجو
            </b-button>

          </div>

        </div>
      </b-collapse>
      <table-items :items="pages" :restoreState="false"/>
      <b-row class="pt-3 mt-3">
        <pagination :meta="paginationMeta" :on-change-page="changePage"/>
      </b-row>
    </template>
  </table-layout>
</template>

<script>
import TableLayout from "../../components/dashboard/TableLayout.vue";
import tableItems from "../../components/dashboard/Content/tableItems.vue";
import {mapGetters} from "vuex";
import Pagination from "../../components/dashboard/Pagination.vue";
import LanguageSelectBox from "../../components/dashboard/Language/LanguageSelectBox";
import SearchFilter1 from "@/plugin/components/dashboard/Filters/Search/SearchFilter1.vue";


export default {
  name: "Product",
  components: {SearchFilter1, TableLayout, tableItems, Pagination, LanguageSelectBox},
  computed: {
    ...mapGetters({
      pages: "Content/getContents",
      paginationMeta: "Content/getPaginationMeta",
    }),
  },
  mounted() {
    this.getItems();
  },
  methods: {
    changePage(page) {
      this.$store.dispatch("Content/getDashboardContents", {type: "page", page: page});
    },
    getItems() {
      this.$store.dispatch('Content/getDashboardContents', {type: "page", page: 1})
    },
    setSearch(words){
      this.$store.commit('Content/setFilters', {key: 'search', value: words.searchWords})
      this.getItems()
    },
    triggerSearch() {
      const searchWords = this.$refs.searchComponent.searchWords || ''; // مقدار فیلد جستجو
      this.setSearch({ searchWords });
    }
  },
  destroyed() {
    this.$store.commit('Content/setFilters', {key: 'search', value: ''})
  }
};
</script>